

import { types } from "../types"


export const getPackegeById = (params, userId) => {
    return {
        type: types.GET_PACKAGE_LIST_BY_USER_ID_REQUEST,
        params, userId
    }
}


export const activePackageForUserAction = (params, userId) => {
    return {
        type: types.ACTIVE_PACKAGE_FOR_USER_REQUEST,
        params, userId
    }
}


export const getAvailablePackageListAction = (params) => {
    return {
        type: types.AVAILABLE_PACKAGE_LIST_REQUEST,
        params
    }
}


export const updatePackageAction = (params) => {
    return {
        type: types.UPDATE_PACKAGE_REQUEST,
        params
    }
}

export const resetPackagePropsAction = () => {

    return {
        type: types.PACKAGE_RESET_PROPS,

    }
}


export const getInvoiceDetailAction = (params) => {

    return {
        type: types.GET_USER_INVOICE_REQUEST,
        params
    }
}



export const getUserInvoicesAction = (params) => {

    return {
        type: types.GET_INVOICELIST_REQUEST,
        params
    }
}


export const getPackageByPackageIdAction = (params) => {

    return {
        type: types.GET_PACKAGE_BY_ID_REQUEST,
        params
    }
}

/// To Upgrade package



export const getUpgradablePackagesAction = (params) => {

    return {
        type: types.GET_UPGRADABLE_PACKAGES_REQUEST,
        params
    }
}



export const getPackageServiceIdAction = (params) => {

    return {
        type: types.GET_PACKAGE_SERVICE_ID_REQUEST,
        params
    }
}



export const upgradePackageAction = (params) => {

    return {
        type: types.GET_UPGRADE_PACKAGE_REQUEST,
        params
    }
}



export const getClientProductAction = (params) => {

    return {
        type: types.GET_CLIENT_PRODUCT_REQUEST,
        params
    }
}



export const setActivePackageAction = (action) => {

    return {
        type: types.SET_ACTIVE_PACKAGE,
        action
    }
}


export const resetUserPackagesAction = () => {

    return {
        type: types.RESET_USER_PACKAGE

    }
}